import { render, staticRenderFns } from "./userprotocol.vue?vue&type=template&id=a9ff3bec&scoped=true"
import script from "./userprotocol.vue?vue&type=script&lang=js"
export * from "./userprotocol.vue?vue&type=script&lang=js"
import style0 from "./userprotocol.vue?vue&type=style&index=0&id=a9ff3bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ff3bec",
  null
  
)

export default component.exports